import React from 'react'
import Table from '@material-ui/core/Table'
import { FormaPagamento } from 'models/Viabilidade/FormaPagamento'
import {
  TableContainerCustomizado,
  TableCellLabel,
  TableRowAlternada,
  TableRowVerde,
  TableCellValor,
  TableCellBold,
  TableCellBoldAlignRight
} from '../index.style'
import { parsePorcentagem } from 'helpers/formatador'
import NumberFormat from 'react-number-format'

const CartaoFormaDePagamento: React.FC<{ dados: FormaPagamento }> = ({ dados }) => {
  return (
    <TableContainerCustomizado>
      <Table data-cy="tableFormaPagamento">
        <TableRowAlternada>
          <TableCellLabel>Total pago em dinheiro (R$)</TableCellLabel>
          <TableCellValor data-cy="campoTotalPagoDinheiro">
            <NumberFormat
              value={dados.totalPagoDinheiro}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            />
          </TableCellValor>
        </TableRowAlternada>
        <TableRowAlternada>
          <TableCellLabel>Provisão Correção Terreno</TableCellLabel>
          <TableCellValor data-cy="campoProvisaoCorrecaoTerreno">
            <NumberFormat
              value={dados.provisaoCorrecaoTerreno}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            />
          </TableCellValor>
        </TableRowAlternada>
        <TableRowAlternada>
          <TableCellLabel>Permuta Física Fora do Local (R$)</TableCellLabel>
          <TableCellValor data-cy="campoPermutaForaDoLocalFiscal">
            <NumberFormat
              value={dados.permuta.permutaForaDoLocalFiscal}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            />
          </TableCellValor>
        </TableRowAlternada>
        <TableRowAlternada>
          <TableCellLabel>Permuta Física Local - Casas (R$)</TableCellLabel>
          <TableCellValor data-cy="campoPermutaNoLocalFiscalCasas">
            <NumberFormat
              value={dados.permuta.permutaNoLocalFiscalCasas}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            />
          </TableCellValor>
        </TableRowAlternada>
        <TableRowAlternada>
          <TableCellLabel>Permuta Física Local - Lotes (R$)</TableCellLabel>
          <TableCellValor data-cy="campoPermutaNoLocalFiscalLotes">
            <NumberFormat
              value={dados.permuta.permutaNoLocalFiscalLotes}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            />
          </TableCellValor>
        </TableRowAlternada>
        <TableRowAlternada>
          <TableCellLabel>Permuta Financeira Bruta (% VGV)</TableCellLabel>
          <TableCellValor data-cy="campoPorcetagemVgvPermutaFinanceiraBruta">
            <NumberFormat
              value={dados.permuta.porcetagemVgvPermutaFinanceiraBruta}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
              suffix="%"
              decimalScale={2}
              fixedDecimalScale={true}
            />
          </TableCellValor>
        </TableRowAlternada>
        <TableRowAlternada>
          <TableCellLabel>Desconto Permuta Financeira (%)</TableCellLabel>
          <TableCellValor data-cy="campoPorcentagemDescontoPermutaFinanceira">
            <NumberFormat
              value={dados.permuta.porcentagemDescontoPermutaFinanceira}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
              suffix="%"
              decimalScale={2}
              fixedDecimalScale={true}
            />
          </TableCellValor>
        </TableRowAlternada>
        <TableRowAlternada>
          <TableCellLabel>Permuta Financeira Líquida (%)</TableCellLabel>
          <TableCellValor data-cy="campoPorcetagemPermutaFinanceiraLiquida">
            <NumberFormat
              value={parsePorcentagem(dados.permuta.porcetagemPermutaFinanceiraLiquida as string)}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
              suffix="%"
              decimalScale={2}
              fixedDecimalScale={true}
            />
          </TableCellValor>
        </TableRowAlternada>
        <TableRowAlternada>
          <TableCellLabel>+ Permuta Financeira Bruta (R$)</TableCellLabel>
          <TableCellValor data-cy="campoPermutaFinanceiraBruta">
            <NumberFormat
              value={dados.permuta.permutaFinanceiraBruta}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            />
          </TableCellValor>
        </TableRowAlternada>
        <TableRowAlternada>
          <TableCellLabel>- Desconto (R$)</TableCellLabel>
          <TableCellValor data-cy="campoDesconto">
            <NumberFormat value={dados.desconto} displayType="text" thousandSeparator="." decimalSeparator="," allowEmptyFormatting={true} defaultValue="-" />
          </TableCellValor>
        </TableRowAlternada>
        <TableRowAlternada>
          <TableCellLabel>= Permuta Financeira Líquida (R$)</TableCellLabel>
          <TableCellValor data-cy="campoPermutaFinanceiraLiquida">
            <NumberFormat
              value={dados.permuta.permutaFinanceiraLiquida}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            />
          </TableCellValor>
        </TableRowAlternada>
        <TableRowAlternada>
          <TableCellLabel>Valor Escriturado do Terreno (R$)</TableCellLabel>
          <TableCellValor data-cy="campoValorEscrituradoTerreno">
            <NumberFormat
              value={dados.permuta.valorEscrituradoTerreno}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            />
          </TableCellValor>
        </TableRowAlternada>
        <TableRowAlternada>
          <TableCellLabel>Despesas Acessórias (R$)</TableCellLabel>
          <TableCellValor data-cy="campoDespesasAcessorias">
            <NumberFormat
              value={dados.valorDespesasAcessorias}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            />
          </TableCellValor>
        </TableRowAlternada>
        <TableRowVerde>
          <TableCellBold>Terreno Total (R$)</TableCellBold>
          <TableCellBoldAlignRight data-cy="campoTerrenoTotal">
            <NumberFormat
              value={dados.terrenoTotal}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            />
          </TableCellBoldAlignRight>
        </TableRowVerde>
      </Table>
    </TableContainerCustomizado>
  )
}

export default CartaoFormaDePagamento
